export default "__VITE_ASSET__Cpq6MAW___"